import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { NgxImageCompressFormat, NgxImageCompressService } from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class MantenimientoDetalleModal implements OnInit {
  public form: FormGroup;
  llimite: string;
  public fileList: File[] = [];
  public imagesList: any[] = [];
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MantenimientoDetalleModal>,
    private imageCompress: NgxImageCompressService
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.llimite = new Date().toISOString().slice(0, 10);
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Descripcion: [""],
    });
  }

  save() {
    const form = this.form.value;
    const data = { Descripcion: form.Descripcion, files: this.fileList };
    this.dialogRef.close({
      ...data,
    });
  }
  public getFile() {
      this.imageCompress
        .uploadMultipleFiles()
        .then((arrayOfFiles: NgxImageCompressFormat[]) => {
          for (let index = 0; index < arrayOfFiles.length; index++) {
            const element = arrayOfFiles[index];
            this.imageCompress
              .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
              .then((compressedImage) => {
                const blob = dataURItoBlob(compressedImage);
                this.imagesList.push(compressedImage);
                this.fileList.push(
                  new File([blob], "Imagen" + new Date().getTime().toString(16)),
                );
              });
          }
        });
  }
  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }
}
